<div class="category-search category-autocomplete">
  <div class="category-search-wrapper complete-autocomplete-disabled" *ngIf="!isCreateModal">
    <app-auto-complete id="ac-category-search-customer{{subId}}" listId="ac-category-search-customer-list{{subId}}"
      noRecordText="No category match your search" noRecordIcon="fal fa-user font-16 pr-2" tooltipPosition="top"
      tooltipStyleClass="tooltip-category-search" styleClassInputWrapper="p-0 pl-1" styleClassListWrapper="w-100"
      styleClassInput="p-1" scrollHeight="250px" itemWidth="450px" [placeholder]="placeholder || 'Search category'"
      [theme]="theme" [leftIcon]="placeholder ? 'fal fa-search font-gray' : ''" [highlightFirstOption]="false"
      [pTooltip]="selectedValue.length > 52 ? selectedValue : ''" [autoFocus]="subId === '2'" [suggestions]="data"
      [disabled]="(theme !== 'border' && selectedValue && (isLastItemSelected || isCloseDropdown || isDisabledSearch)) || !canEditClassifications"
      [value]="theme === 'border' ? query : selectedValue" [textTruncate]="true"
      [hasSearchIcon]="placeholder ? false : true" [isLoading]="isLoading" [showSelectedValue]="true"
      [defaultSuggestions]="data" [closeOnSelection]="isLastItemSelected" [openDropdownOnGetResult]="true"
      [hasEditableField]="false" (appSelect)="handleSelect($event)" (appClear)="handleClear()"
      (appCompletedMethod)="pageIndex = 0; totalPages = 0; handleSearch($event)" (appEnter)="onSearchEnter()"
      (appClickOutside)="closeDropdown()">
      <ng-template let-item let-index="index" let-query="query" appTemplate="item" let-close="close">
        <div id="accordion">
          <div class="category-search-accordion-wrapper" [attr.aria-labelledby]="item?.categoryId">
            <div class="btn btn-link" (click)="getSubcategories(item, index, true)" data-toggle="collapse"
              [attr.data-target]="'#category' + item?.categoryId" aria-expanded="false"
              [attr.aria-controls]="'category' + item?.categoryId">
              <div class="category-search-header-btn" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center" [pTooltip]="categoryChecked('category', 'categoryId', item?.categoryId) ? categoryTooltip : ''">
                <div class="cat-icon-wrapper">
                  <i [ngClass]="isLoadingSubCat[selectedId] && item.categoryId == selectedId ? 'fad fa-spinner-third rotate' : 'fal fa-chevron-down'"
                    class="pr-1 font-primary fal-icon"></i>
                </div>
                <!-- <i class="checkbox-round"></i> -->
                <div class="d-flex" [ngClass]="{'not-allowed opacity-5': categoryChecked('category', 'categoryId', item?.categoryId)}">
                  <app-radio-button id="status-confirm+{{ item.categoryId }}" name="apt-status+{{ item.categoryId }}"
                    styleClassLabel="font-seconday" [selectedValue]="selectedLevel1" [value]="item?.categoryId"
                    (appChange)="handleLevel1Change(item, index)">
                  </app-radio-button>
                  <span (click)="change()" [innerHTML]="highlighedSearchText(item.categoryName, query)"></span>
                </div>
              </div>
            </div>
            <div [id]="'category'+item?.categoryId" class="collapse" [attr.aria-labelledby]="item?.categoryId"
              [data-parent]="'#accordion'">
              <div class="category-search-item-wrapper level-1">
                <!-- LEVEL-2 -->
                <div id="accordion" *ngFor="let level2 of item?.subItems; let j = index" >
                  <div class="category-search-accordion-wrapper category-sub-item">
                    <div class="btn btn-link px-0 py-1" (click)="getSubSubcategories(item, level2, index, true)"
                      data-toggle="collapse" [attr.data-target]="'#category' + level2?.subCategoryId"
                      aria-expanded="false" [attr.aria-controls]="'category' + level2?.subCategoryId">
                      <div class="category-search-header-btn" tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center"
                        [pTooltip]="categoryChecked('subCategory', 'subCategoryId', level2?.subCategoryId) ? categoryTooltip : ''">
                        <div class="cat-icon-wrapper">
                          <i [ngClass]="isLoadingSubCat[level2?.subCategoryId] && level2?.subCategoryId == selectedId ? 'fad fa-spinner-third rotate' : 'fal fa-chevron-down'"
                            class="pr-1 font-primary fal-icon"></i>
                        </div>
                        <div class="d-flex"
                          [ngClass]="{'not-allowed opacity-5': categoryChecked('subCategory', 'subCategoryId', level2?.subCategoryId)}">
                          <app-radio-button id="status-confirm+{{ level2?.subCategoryId }}"
                            name="apt-status+{{ level2?.subCategoryId }}" styleClassLabel="font-seconday"
                            [selectedValue]="selectedLevel2" [value]="level2?.subCategoryId"
                            (appChange)="handleLevel2Change(level2,item, j)">
                          </app-radio-button>
                          <span (click)="change()"
                            [innerHTML]="highlighedSubSearchText(level2?.subCategoryName, query)"></span>
                        </div>
                      </div>
                    </div>


                    <div [id]="'category' + level2?.subCategoryId" class="collapse"
                      [attr.aria-labelledby]="level2?.subCategoryId" [data-parent]="'#accordion'">
                      <!-- LEVEL-3 -->
                      <ng-container *ngFor="let level3 of level2?.subItems; let k = index">
                        <div class="category-search-accordion-wrapper category-sub-item" tooltipPosition="top"
                         tooltipStyleClass="tooltip-width-medium text-center" [pTooltip]="categoryChecked('subSubCategory', 'subSubCategoryId', level3?.subSubCategoryId) ? categoryTooltip : ''">
                          <div class="category-search-item-wrapper level-2" [ngClass]="{'not-allowed opacity-5': categoryChecked('subSubCategory', 'subSubCategoryId', level3?.subSubCategoryId)}">
                            <div class="category-search-header-btn">
                              <app-radio-button id="status-confirm+{{ level3?.subSubCategoryId }}" name="apt-status"
                                styleClassLabel="font-seconday" [selectedValue]="selectedLevel3"
                                [value]="level3?.subSubCategoryId"
                                (appChange)="handleLevel3Change(level3,level2,item); handleCloseDropdown()">
                              </app-radio-button>
                              <span (click)="change()"
                                [innerHTML]="highlighedSubSearchText(level3?.subSubCategoryName, query)"></span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="index === results.length - 1 && pageIndex < totalPages && results.length < totalRecords"
          class="font-primary mb-0 p-2 flex-center-center" (click)="handleShowMore($event)">
          Show more
          <i *ngIf="isLoadingMore" class="fal fa-spinner rotate ml-2"></i>
        </p>
      </ng-template>
    </app-auto-complete>
    <div class="remove-item pointer" *ngIf="theme !== 'border' && selectedValue" (click)="handleDeleteItem()">
      <i class="fal fa-times" [ngClass]="{ 'font-primary': focus?.cross }"></i>
    </div>
  </div>
</div>
